import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

export function exact(datetime) {
    return dayjs(datetime).format("YYYY-MM-DD HH:mm:ss");
}

export function time(datetime) {
    return dayjs(datetime).format("HH:mm:ss");
}

export function ago(datetime) {
    return dayjs(datetime).fromNow();
}
